<template>
    <div>
        <div class="page">
          <el-select @change="select" style="width: 110px;margin-right: 10px;"  size="small" v-model="page.showNumber" placeholder="请选择">
            <el-option
              v-for="item in pageSize"
              :key="item.value"
              :label="item.label"
              :value="item.value"> 
            </el-option>
          </el-select>
          <el-button round icon="el-icon-arrow-left" :disabled="page.isPre" @click="pre" size="small">上一页</el-button>
          <el-button round  size="small" :disabled="page.isNext" @click="next">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
         <TableBlock ref="tableData" :columns="columns" :action="action" :showBtn="false" :ispage="false" :autRequest="false"  :param="param" :navHeight="260"  @checkVal="getCheckVal">
          <div class="common-items-center common-space-between">
            <div class="common-items-center">
              <InputBlock title="消息ID">
                <el-input v-model="param.id" :size="this.$store.state.inputSize" placeholder="请输入消息ID"/>
              </InputBlock>
              <InputBlock title="序列号/IMEI">
                <el-input v-model="param.deviceId" :size="this.$store.state.inputSize" placeholder="请输入序列号/IMEI" />
              </InputBlock>
              <span style="margin-right: 10px;font-size: 14px;color: #606266;">选择时间</span>
              <el-date-picker
                :clearable="false"
                @blur="setDate"
                v-model="date"
                type="date"
                placeholder="选择日期">
              </el-date-picker>

              <el-time-picker
                :clearable="false"
                @blur="isTime"
                v-model="time1"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59'
                }"
                placeholder="开始时间">
              </el-time-picker>

              <el-time-picker
                :clearable="false"
                @blur="isTime"
                v-model="time2"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59'
                }"
                placeholder="结束时间">
              </el-time-picker>

              <el-button :size="this.$store.state.btnSize" type="primary" icon="el-icon-search" @click="serachBtn">查询</el-button>
              <el-button :size="this.$store.state.btnSize" type="danger"  icon="el-icon-refresh-left" @click="resetBtn">重置</el-button>
            </div>
          </div>
         </TableBlock>
         <el-dialog title="日志详情" :visible.sync="dialogVisible"  width="1260px"  :before-close="handleClose">
            <!-- <div><pre>{{dataJson}}</pre></div> -->
            <div><json-viewer :value="dataJson"></json-viewer></div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </div>
          </el-dialog>
    </div>
  </template>
  <script>
  import {columns} from './columns-message';
  import {getDate,getTime} from '@/utils/util'
  import {userApi,operate,url,api,iotApi} from '@/utils/config'
  import {postFun,deleteFun,getFun} from '@/utils/httpFun'

  export default {
    name: 'index',
    watch:{
      date(newDate,preDate){
        console.log("呃呃呃",newDate)
        if(!!!newDate){
          console.log('侧1')
          this.time1 = null;
          this.time2 = null;
          return;
        }
      }
    },
    data:()=>({  
      columns:[],
      dialogVisible:false,
      dataJson:{},
      action:iotApi.DEVICELOG,
      param:{
        id:null,
        deviceId:null,
        startTime:"2023-04-25 00:00:00",
        endTime:"2023-04-25 23:59:59"
      },
      page:{
        pageSize:20,
        pageNo:1,
        showNumber:20,
        isPre:false,
        isNext:false,
      },
      date:'',
      time1:'',
      time2:'',
      strDate:'',
      pageSize:[
        {
          value:10,
          label:'10条/页'
        },
        {
          value:20,
          label:'20条/页'
        },
        {
          value:30,
          label:'30条/页'
        },
        {
          value:50,
          label:'50条/页'
        },
        {
          value:100,
          label:'100条/页'
        },
      ]
    }),
    created(){
      this.columns = columns(this);
      this.default()
      this.$nextTick(()=>{
        this.$refs.tableData.getPageDatas(this.page)
      })
    },
    methods:{
      // 上一页
      pre(ev){
        console.log("上一页",ev)
        this.page.pageNo--;
        this.page.isNext?this.page.isNext = false:''
        this.$nextTick(()=>{
          this.$refs.tableData.getPageDatas(this.page)
        })
      },
      // 下一页
      next(ev){
        console.log('下一页',ev)
        this.page.pageNo++;
        this.page.isPre?this.page.isNext = false:''
        this.$nextTick(()=>{
          this.$refs.tableData.getPageDatas(this.page)
        })
      },
      // 一页总数
      select(ev){
        this.page.pageSize = ev;
        this.$nextTick(()=>{
          this.$refs.tableData.getPageDatas(this.page)
        })
      },
      default(){
        this.date = new Date();
        this.strDate = getDate(this.date);
        let dateArr = this.strDate.split('-')
        this.time1 = new Date(dateArr[0],dateArr[1],dateArr[2],0,0,0)
        this.time2 = new Date(dateArr[0],dateArr[1],dateArr[2],23,59,59)
        this.param.startTime = this.strDate+getTime(this.time1);
        this.param.endTime = this.strDate+getTime(this.time2);
        console.log("默认",this.param,this.strDate,getTime(this.time2),this.time2)
      },
      setDate(ev){
        this.strDate = getDate(this.date);
        let dateArr = this.strDate.split('-')
        this.time1 = new Date(dateArr[0],dateArr[1],dateArr[2],0,0,0)
        this.time2 = new Date(dateArr[0],dateArr[1],dateArr[2],23,59,59)
        
        this.param.startTime = this.strDate+getTime(this.time1);
        this.param.endTime = this.strDate+getTime(this.time2);
      },
      isTime(){
        if(!!!this.time1 || !!!this.time2)return;
        let start = this.time1.getTime();
        let end = this.time2.getTime();

        let isTime = false;

        if(start == end)this.$message.warning('开始时间不能等于结束时间');
        else if(start>end)this.$message.warning('开始时间不能大于结束时间');
        else if(end < start)this.$message.warning('结束时间不能小于开始时间');
        else isTime = true;

        if(!isTime){
          this.time1 = null;
          this.time2 = null;
        }

        this.strDate = getDate(this.date);
        let dateArr = this.strDate.split('-');
        
        this.param.startTime = this.strDate+getTime(this.time1);
        this.param.endTime = this.strDate+getTime(this.time2);
      },
  
      //查询
      serachBtn(){
        this.page.pageNo = 1;
        this.$nextTick(res=>{
          this.$refs.tableData.getPageDatas(this.page)
        })
      },
  
      //重置
      resetBtn(){
         this.param.id = null;
         this.param.deviceId = null;
         this.default();
         this.page.pageNo = 1;
         this.page.pageSize = 20;
         this.page.showNumber = 20;
         this.page.isNext = false;
         this.page.isPre = false;
         this.$nextTick(res=>{
          this.$refs.tableData.getPageDatas(this.page)
         })
      },
  
      //查看产品名称的详情
       openProduct(ev){
          getFun(operate.PRODUCTDETAIL+"/"+ev.id+"",{},res=>{
            let data = res.data
            let parms = {
                imgList:res.data.resources,
                list:[
                  {title:"产品名称",val:data.name},
                  {title:"产品分类",val:data.deviceTypeName},
                  {title:"设备分类",val:data.typeName},
                  {title:"产品型号",val:data.model},
                  {title:"企业名称",val:data.factoryName},
                  {title:"协议名称",val:data.protocolName},
                  {title:"更新时间",val:!data.updateTime ? data.createTime : data.updateTime},
                  {title:"协议公司",val:data.factoryName},
                  {title:"最近操作人",val:data.operator},
                  {title:"版本",val:data.protocolVersion},
                  {title:"备注",val:data.describes}
                ]
              }
              this.$refs.lookBlock.openBtn(parms)
          })
       }, 
  
       //查看企业
       openCompany(ev){
          this.$router.replace({
             path:"EnMessage",
             query:{
                factoryId:ev.factoryId
             }
          })
       },
       lookBtn(ev){
          this.dialogVisible = true
          this.dataJson = ev
          // console.log(ev)
       },
      //导出
      exportBtn(){
  
      },

      handleClose(){
        this.dialogVisible = false
      },
      
      //复选框的值
      getCheckVal(){
  
      }
  
    }
  }
  </script>
  <style lang="scss" scoped>
      // 分页
      .page{
        z-index: 99;
        position: absolute;
        bottom: 31px;
        right: 39px;
      }
      ::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 150px;
        margin-right: 13px;
      }
      ::v-deep .el-input--prefix .el-input__inner{
        height: 32px;
      }
      ::v-deep .el-input__prefix, .el-input__suffix{
        top: -4px;
      }
      .container{
          padding:15px;
          box-sizing: border-box;
      }
      .warp-table{
          margin-top: 15px;
          width: 100%;
      }
      .titleText{
         font-size: 14px;
         color: #606266;
      }
      .inputBlock{
         margin-right:20px;
         width: 140px;
      }
      .lookName{
          color: #458EFF;
          cursor: pointer;
      }
  </style>
  